import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Component, Input, OnInit, ViewChild, ElementRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

declare function require(name: string);
const flatpickr = require('flatpickr');
const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');


@Component({
  selector: 'app-single-time-picker',
  templateUrl: './single-time-picker.component.html',
  styleUrls: ['./single-time-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SingleTimePickerComponent implements OnInit {

  @Input()
  public timeFormControl: FormControl;

  @Input()
  public showLabel = 'Select Time';

  @Output()
  public modelChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('inputBox' ,{static: true})
  public inputBox: ElementRef;

  public flatPickerInstance: any;

  constructor() {
  }

  ngOnInit() {
    if (!this.timeFormControl) {
      this.timeFormControl = new FormControl(null);
    }

    const datePickerComponent = this;
    this.flatPickerInstance = flatpickr(
        this.inputBox ? this.inputBox.nativeElement : 'input[data-input-type=time-component].date-field-width',
        {
          mode: 'single',
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          dateFormat: 'h:i:S K',
          minuteIncrement: 1,
          time_12hr: true,
          onOpen: [
            (selectedDates, dateStr, instance) => {
              if (!this.timeFormControl.value) {
                instance.clear();
              }
            }
          ],
          onValueUpdate: (date) => {
            if (date[0]) {
              datePickerComponent.timeFormControl.setValue(flatpickr.formatDate(date[0], 'h:i:S K'));
            }
          },
          onClose() {
            const timer: Subscription = TimerObservable.create(0, 10).subscribe(
              () => {
                datePickerComponent.onChange();
                timer.unsubscribe();
              }
            );
          },
          onReady() { this.showTimeInput = true },
          'plugins': [new confirmDatePlugin({showAlways: true})]
        }
    );
  }

  public clear() {
    if (this.flatPickerInstance) {
      this.flatPickerInstance.clear();
    }
  }

  private onChange() {
    this.modelChange.emit(this.timeFormControl.value);
  }
}
